import type { FC } from 'react';

import { NT_PURCHASE_PAGE_LINK } from '../../../../domain/gainAccessView';
import { translate } from '../../../../services/i18n';

import { StyledTooltipContainer, StyledTooltipText, StyledTooltipTitle, StyledUpgradeLink } from './styles';

type RevealQuotasTooltipContentProps = {
  title: string;
  description: string;
};

export const RevealQuotasTooltipContent: FC<RevealQuotasTooltipContentProps> = ({ title, description }) => (
  <StyledTooltipContainer>
    <StyledTooltipTitle>{title}</StyledTooltipTitle>
    <StyledTooltipText>{description}</StyledTooltipText>
    <StyledUpgradeLink href={NT_PURCHASE_PAGE_LINK} target="_blank" rel="noreferrer">
      {translate('si.common.upgrade_now')}
    </StyledUpgradeLink>
  </StyledTooltipContainer>
);
